<ng-container *ngFor="let btn of buttons; trackBy: trackById">
  <ui-icon
    [clickable]="true"
    (clicked)="onActionClicked(btn)"
    [name]="btn.icon"
    [color]="btn.color"
  ></ui-icon>
</ng-container>
